import { AbilityBuilder, createMongoAbility } from '@casl/ability';

export function buildAbility(role, userActions = {}, rolesAndActions = null) {
  const { can, build } = new AbilityBuilder(createMongoAbility);

  if (role === 'SUPER_ADMIN') {
    can('manage', 'all');
    return build();
  }

  if (rolesAndActions && rolesAndActions.actions) {
    const validActionsSet = new Set();
    rolesAndActions.actions.forEach(group => {
      (group.actions || []).forEach(actionObj => {
        if (actionObj.roles && actionObj.roles.includes(role)) {
          validActionsSet.add(actionObj.action);
        }
      });
    });

    const validActions = Array.from(validActionsSet);

    validActions.forEach(key => {
      // Missing key or explicitly 'ALLOWED'
      if (userActions && userActions[key] === 'RESTRICTED') {
        // Skip
      } else {
        can(key, 'all');
      }
    });
  }

  return build();
}
